// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "footer__buttons-1eWOf";
var _3 = "footer__clear-vGOP0";
var _4 = "footer__done-1oLEc";
export { _1 as "__esModule", _2 as "footer__buttons", _3 as "footer__clear", _4 as "footer__done" }
export default { "__esModule": _1, "footer__buttons": _2, "footer__clear": _3, "footer__done": _4 }
